"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { TourProvider } from "./tour-provider";
import { TourReminderBanner } from "./tour-reminder-banner";

interface OptimizerOnboardingShellProps {
  children: React.ReactNode;
  userId: string | null;
  initialTourCompleted: boolean;
  startDelay?: number;
}

export function OptimizerOnboardingShell({
  children,
  userId,
  initialTourCompleted,
  startDelay = 2000,
}: OptimizerOnboardingShellProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  
  const isOptimizerRoot = pathname === "/optimizer";
  const shouldRestartTour = searchParams?.get("restart_tour") === "true";

  if (!userId) {
    return <>{children}</>;
  }

  return (
    <TourProvider
      startDelay={startDelay}
      initialTourCompleted={initialTourCompleted}
      userId={userId}
      shouldRestart={shouldRestartTour}
      autoShowWelcome={isOptimizerRoot}
    >
      {isOptimizerRoot ? (
        <TourReminderBanner
          userId={userId}
          tourCompleted={initialTourCompleted}
        />
      ) : null}
      {children}
    </TourProvider>
  );
}
